import { Icon, IconProps } from './Icon';

export type PhoneProps = IconProps;

export const Phone = (props: PhoneProps) => (
  <Icon width="16px" height="16px" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path d="M10 1.333v.934c0 .373 0 .56-.073.702a.667.667 0 0 1-.291.292c-.143.072-.33.072-.703.072H7.067c-.374 0-.56 0-.703-.072a.667.667 0 0 1-.291-.292C6 2.827 6 2.64 6 2.267v-.934m-.533 13.334h5.066c.747 0 1.12 0 1.406-.146.25-.128.455-.332.582-.582.146-.286.146-.659.146-1.406V3.467c0-.747 0-1.12-.146-1.406a1.333 1.333 0 0 0-.582-.582c-.286-.146-.659-.146-1.406-.146H5.467c-.747 0-1.12 0-1.406.146-.25.127-.454.331-.582.582-.146.285-.146.659-.146 1.406v9.066c0 .747 0 1.12.146 1.406.128.25.332.454.582.582.286.146.659.146 1.406.146Z" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
)
